<template>
    <v-menu
        @input="updateFilterMenu($event)"
        :value="filter_menu"
        offset-y
        left
        origin="right top"
        content-class="notification-dropdown"
        :close-on-content-click="false"
        full-width
    >
        <bc-tooltip slot="activator">
            <v-btn icon slot="activator" :color="active_filter ? 'orange' : ''">
                <v-icon :color="active_filter ? 'white' : 'black'">search</v-icon>
            </v-btn>
            {{ $t('lang.filter') }}
        </bc-tooltip>
        <div class="dropdown-content">
            <v-card class="pt-2">
                <slot :filter_menu="filter_menu"></slot>
                <v-card-actions>
                    <slot name="actions">
                        <v-spacer></v-spacer>
                        <v-btn
                            flat
                            @mouseup.left="clearFilter()"
                            :disabled="$route.fullPath == $route.path || !active_filter"
                        >
                            {{ $t('lang.clear') }}
                        </v-btn>

                        <v-btn
                            color="primary"
                            flat
                            @mouseup.left="filterTool(params)"
                            :disabled="(params && Object.keys(params).length === 0 && unchangedQuery) || unchangedQuery"
                        >
                            {{ $t('lang.search') }}
                        </v-btn>
                    </slot>
                </v-card-actions>
            </v-card>
        </div>
    </v-menu>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: ["params"],
    computed: {
        ...mapState({
            filter_menu: (state) => state.settings.filter_menu,
        }),
        active_filter() {
            return Object.keys(this.$route.query).filter((q) => q.toLowerCase() != "page_num" && q.toLowerCase() != "page_size").length > 0;
        },
        unchangedQuery() {
            return JSON.stringify(this.params) == JSON.stringify(this.$route.query);
        },
    },
    watch: {
        filter_menu: function(newVal) {
            if (newVal) {
                this.$emit("open");
            }
        },
    },
};
</script>
